/** @format */

import React, { useEffect, useState, useRef } from 'react';
import { flushSync } from 'react-dom';
import Page from 'src/components/Page';
import { WelcomeTitle, WidgetGrid } from '../../components';
import useAuth from 'src/hooks/useAuth';
import Can from 'src/components/Can';
import { useTranslation } from 'react-i18next';
import Breadcrumb from 'src/components/Breadcrumb';
import SurveyModal from 'src/components/surveyModal';
import { useSelector } from 'src/store';
import { missingRequiredFieldsChecking } from '../survey';
import { Redirect } from 'react-router-dom';
import { DashboardSkeleton } from 'src/components/dashboard/DashboardSkeleton';
import { Box } from '@material-ui/core';

const startViewTransition = callback => {
  if (document.startViewTransition) {
    document.startViewTransition(() => {
      flushSync(callback);
    });
  } else {
    callback();
  }
};

const HomeView = () => {
  const { user } = useAuth();
  const { t, i18n } = useTranslation();
  const [showSurvey, setShowSurvey] = useState(false);

  const { userData, currentUserDashboard, userLoading, widgetInfo } = useSelector(state => state.users);

  const [displayedContent, setDisplayedContent] = useState({ loading: true });
  const prevLoadingRef = useRef(true);

  const loading = user && (userLoading || widgetInfo === null);

  const breadcrumbData = [
    {
      title: t('dashboard')
    }
  ];

  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      if (missingRequiredFieldsChecking(userData)) setShowSurvey(true);
    }
  }, [userData]);

  useEffect(() => {
    const wasLoading = prevLoadingRef.current;
    prevLoadingRef.current = loading;

    if (wasLoading && !loading) {
      startViewTransition(() => {
        setDisplayedContent({ loading: false });
      });
    } else if (loading && !wasLoading) {
      setDisplayedContent({ loading: true });
    } else if (!loading) {
      setDisplayedContent({ loading: false });
    }
  }, [loading]);

  /**
   * Tracks the dashboard loaded event in dataLayer
   * Sends language parameter only if it's not present in the URL
   */
  useEffect(() => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('language') && window.trackDataLayer) {
      window.trackDataLayer('language', { language: i18n.language }, user);
    }
  }, [i18n.language]);

  const welcomeTitle = `${user && user.firstName && t('welcome')} ${user && user.firstName} ${user && user.lastName} ${user && user.firstName && '!'}`;

  return (
    <Page className={`dashboard`} title="Dashboard">
      <Breadcrumb data={breadcrumbData} />
      <WelcomeTitle>{welcomeTitle}</WelcomeTitle>
      <Box style={{ viewTransitionName: 'home-widget-grid' }}>
        {displayedContent.loading && user ? <DashboardSkeleton /> : <WidgetGrid />}
      </Box>
      {showSurvey && <SurveyModal />}
    </Page>
  );
};

export default HomeView;
